import { t } from 'ttag'
import { PureComponent } from 'react'
import styled from 'styled-components'

import videoPaused from '@h2/assets/svg/icons/videoPaused.svg'
import videoGreen from '@h2/assets/svg/icons/videoGreen.svg'
import volumeFull from '@h2/assets/svg/icons/volumeFull.svg'
import volumeMute from '@h2/assets/svg/icons/volumeMute.svg'
import { TaskProgressBar } from '@h2/components/display/taskProgressBar'

const FullImage = styled.img`
  width: 100%;
  height: 100%;
`

class H2VideoPlayer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      videoPlayerDuration: 0,
      videoPlayerPosition: 0,
      videoBuffered: 0,
      videoBufferedInRangeMax: 0,
      videoVolume: 100
    }
    this.playerRef = null
  }

  timeUpdated = e => {
    let bufferedTimeStrMax = 0

    for (let i = 0; i < e.target.buffered.length; i++) {
      if (
        e.target.currentTime >= e.target.buffered.start(i) &&
        e.target.currentTime <= e.target.buffered.end(i)
      ) {
        bufferedTimeStrMax = e.target.buffered.end(i)
        break
      }
    }

    //   console.log(e.target.buffered, e.target.buffered.start(0), e.target.buffered.end(0))
    this.setState({
      ...this.state,
      videoPlayerDuration: e.target.duration,
      videoPlayerPosition: e.target.currentTime,
      videoBufferedInRangeMax: bufferedTimeStrMax,
      videoBuffered: e.target.buffered //.start(idx), .end(idx)
    })
  }

  initialInfo = e => {
    this.setState({ ...this.state, videoPlayerDuration: e.target.duration })
  }

  togglePlayback = () => {
    //console.log(this.playerRef)
    if (this.playerRef.paused) {
      this.playerRef.play()
    } else {
      this.playerRef.pause()
    }
  }

  setVolume = pct => {
    //  console.log(this.playerRef)
    this.playerRef.volume = pct / 100
  }

  toMinSec = time => {
    if (isNaN(time)) {
      return `0:00`
    }

    const hours = Math.floor(time / 3600)
    //console.log("Hours: " + hours + ", " + time + " -- " + (time / 3600))
    const minutes = Math.floor((time - hours * 3600) / 60)
    //console.log("Minutes: " + minutes + ", " + time + " -- " + (time / 60))
    const seconds = Math.floor(Math.round(time) - hours * 3600 - minutes * 60)
    const padNum = (string, length) => {
      return (new Array(length + 1).join(0) + string).slice(-length)
    }

    if (hours > 0) {
      return `${hours}:${minutes}:${padNum(seconds, 2)}`
    }

    return `${minutes}:${padNum(seconds, 2)}`
  }

  onVolumeChange = v => {
    this.setState({
      ...this.state,
      videoVolume: v.target.volume
    })
  }

  onSeek = evt => {
    if (this.props.allowSeek) {
      //const rect = document.body.getBoundingClientRect();
      const ele = evt.target.classList.contains('progress-task-bar')
        ? evt.target
        : evt.target.closest('.progress-task-bar')
      const elemRect = ele.getBoundingClientRect()
      const eleWidth = elemRect.right - elemRect.left
      const clickPos = evt.pageX - elemRect.left
      const pct = clickPos / eleWidth
      const seekTime = Math.round(this.state.videoPlayerDuration * pct)

      this.playerRef.currentTime = isNaN(seekTime) ? 0.0 : seekTime
    }
  }

  render = () => {
    let timeStr = Math.round(
      100 * (this.state.videoPlayerPosition / this.state.videoPlayerDuration)
    )

    timeStr = timeStr ? timeStr : 0
    let bufferedTimeStr = Math.round(
      100 * (this.state.videoBufferedInRangeMax / this.state.videoPlayerDuration)
    )

    bufferedTimeStr = bufferedTimeStr ? bufferedTimeStr : 0

    const onComplete = this.props.onComplete ? this.props.onComplete : () => {}
    const props =
      !this.playerRef || this.playerRef.paused ? { onClick: this.togglePlayback } : {}
    const labelledby = this.props['aria-labelledby']
    const addProps = labelledby ? { 'aria-labelledby': labelledby } : {}

    return (
      <div className="headed2-video-player">
        <div
          className={`embed-responsive ${
            !this.props.ratio43 ? `embed-responsive-16by9` : `embed-responsive-4by3`
          } ${this.playerRef && !this.playerRef.paused ? 'video-play' : 'video-paused'}`}
          {...props}>
          <video
            ref={p => (this.playerRef = p)}
            onClick={() => this.togglePlayback()}
            onVolumeChange={this.onVolumeChange}
            className="embed-responsive-item"
            onLoad={this.initialInfo}
            onEnded={onComplete}
            preload="auto"
            poster={this.props.poster}
            onTimeUpdate={this.timeUpdated}
            {...addProps}>
            {this.props.children}
          </video>
        </div>
        <TaskProgressBar
          pct={timeStr}
          pct2={bufferedTimeStr}
          incomplete={timeStr < 100}
          onClick={this.onSeek}
        />
        <div className="action-buttons">
          <button
            style={{
              border: 0,
              padding: 0,
              background: 'transparent',
              width: '45px',
              height: '45px',
              float: 'left'
            }}
            onClick={() => this.togglePlayback()}>
            {this.playerRef && !this.playerRef.paused ? (
              <img src={videoPaused} alt={t`Pause`} style={{ height: '45px' }} />
            ) : (
              <img src={videoGreen} alt={t`Play`} style={{ height: '45px' }} />
            )}
          </button>
          <div className="video-stats text-center">
            <span style={{ fontSize: '.8em', float: 'left' }}>
              {this.toMinSec(this.state.videoPlayerPosition)}/
              {this.toMinSec(this.state.videoPlayerDuration)}
            </span>
            <b>{t`${timeStr}% viewed`}</b>
          </div>
          <div
            className="pull-right volume-control"
            style={{ width: '45px', height: '45px', float: 'left' }}>
            <button
              style={{
                border: 0,
                padding: '3px',
                background: 'transparent'
              }}
              onClick={() => this.setVolume(this.state.videoVolume > 0 ? 0 : 100)}>
              {this.state.videoVolume > 0 ? (
                <FullImage src={volumeMute} alt={t`Sound Off`} />
              ) : (
                <FullImage src={volumeFull} alt={t`Sound On`} />
              )}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default H2VideoPlayer
